<div class="row">
    <div class="col-12">
        <p-breadcrumb [model]="items" [home]="home"></p-breadcrumb>
    </div>
    <!-- <div class="col-2 mt-3">
        <a [hidden]="!store.web" [href]="store.webLink" target="_blank"><img class="web-icon me-2"
                src="../../../../assets/images/web-icon.png" /></a>
        <a [hidden]="!store.android" [href]="store.androidLink" target="_blank"><img class="web-icon me-2"
                src="../../../../assets/images/play-store.png" /></a>
        <a [hidden]="!store.ios" [href]="store.iosLink" target="_blank"><img class="web-icon"
                src="../../../../assets/images/app-store.png" /></a>
    </div> -->
</div>